// @ts-nocheck
// https://www.npmjs.com/package/@monaco-editor/react
// Preferable to official integration b/c no webpack modifications are needed
// (Keep just for prototyping)
import Editor from "@monaco-editor/react";
import type { Monaco } from "@monaco-editor/react";

// import { KeyCode } from 'monaco-editor/esm/vs/editor/common/standalone/standaloneEnums';
import React from "react";
// import type { TopLevelSpec } from 'vega-lite';
// import { EditorMessage } from 'src/graphpad.types';

// Keep out of global so that this can co-exist with other Monaco editors
function handleEditorWillMount(monacoInstance: Monaco) {
  monacoInstance.languages.json.jsonDefaults.setDiagnosticsOptions({
    allowComments: false,
    enableSchemaRequest: true,
    schemas: [
      {
        uri: "https://vega.github.io/schema/vega-lite/v5.json",
      },
    ],
    validate: true,
  });
  monacoInstance.languages.json.jsonDefaults.setModeConfiguration({
    documentFormattingEdits: false,
    documentRangeFormattingEdits: false,
    completionItems: true,
    hovers: true,
    documentSymbols: true,
    tokens: true,
    colors: true,
    foldingRanges: true,
    diagnostics: true,
  });
  monacoInstance.languages.registerDocumentFormattingEditProvider("json", {
    provideDocumentFormattingEdits(model: any, options: any, token: any) {
      return [
        {
          range: model.getFullModelRange(),
          text: JSON.stringify(JSON.parse(model.getValue())),
        },
      ];
    },
  });
}

interface VegaEditorProps {
  spec: string; // serializable JSON
  setSpec: (spec: string) => void;
  height?: number | string; // CSS height
  onSubmit?: (() => void) | ((spec: string) => void);
}

export const VegaEditor: React.FC<VegaEditorProps> = (props) => {
  const { height = "540px", onSubmit } = props;

  function handleMount(editor: Editor.IStandaloneCodeEditor, monaco: Monaco) {
    // https://microsoft.github.io/monaco-editor/api/interfaces/monaco.editor.iactiondescriptor.html#run
    function submitGraphSpecAction(onRun: OnRun) {
      return {
        id: "run-graph-spec-update",
        label: "Update graph",
        // eslint-disable-next-line no-bitwise
        keybindings: [monaco.KeyMod.CtrlCmd | monaco.KeyCode.Enter],
        run(edt: editor.IStandaloneCodeEditor) {
          console.debug("Running submitGraphSpecAction");
          try {
            // console.log("Attempting to parse model as json");
            const value = edt.getModel().getValue();
            onRun(value);
          } catch (e) {
            console.warn(
              "Error while trying to parse spec as json"
            );
            console.error(e);
          }
        },
      };
    }

    if (onSubmit) {
      // console.log("Graphpad: registering submitGraphSpecAction");
      editor.addAction(submitGraphSpecAction((text: string) => onSubmit(text)));
    }
  }

  return (
    <Editor
      height={height}
      language="json"
      value={props.spec}
      onChange={(val?: string) => {
        let parsedVal = null;
        try {
          parsedVal = JSON.parse(val ?? "");
        } catch {
          console.warn("Vega spec not valid yet");
          return val ?? "";
        }
        if (parsedVal !== null) {
          props.setSpec(val);
        }

        return val ?? "";
      }}
      onMount={handleMount}
      beforeMount={handleEditorWillMount}
      options={{
        minimap: { enabled: false },
      }}
    />
  );
};
